import { defineAppConfig } from '#imports';
import { uiLayerAppConfig } from './constants/app-config';

export default defineAppConfig(uiLayerAppConfig);
